import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_1Screen } from "../SlotGameType1_1Screen";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
//

//namespace SlotGames {

export class CloverGirlGreen20_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {

    protected override helpFactory: IHelpFactory = new CloverGirlGreen20HelpFactory();


    //public override isDeluxGame: boolean = true;
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "CloverGirlGreen20") {
        super(multigameParams, initData, gameName);

        this.spinnableReelsParams.topBorderWidth = 8;
        this.spinnableReelsParams.bottomBorderWidth = 8;
    }

    // protected PrepareFonts(resourceManager: ResourceManager): void {

    //     resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

    // }
    protected override ColorLed:string="57,255,20\n";
     

    protected override color: RewardColor =
        {
            color: "#96DB2A",
            coloroutherStroke: "black",
            colorinnerStroke: "#DB3814",
        }

}
class CloverGirlGreen20HelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new CloverGirlGreen20Help(params);
    }
}

class CloverGirlGreen20Help extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(14, 38, 8),rgb(42, 89, 21), rgb(68, 140, 35),rgb(42, 89, 21),rgb(14, 38, 8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}


